/**
 * Main scripts file
 */

import 'what-input'
import 'svg4everybody'
import './src/lazysizes'
import './vendor/accessible-mega-menu'
import './src/divers'
import './src/menu'
import './src/flickity'
import '../../scripts/mosne'
